import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getManagers = asyncThunkWrapper({ 
  model: 'managers', 
  action: 'getManagers', 
  func: async ({ offset = 0, query = null }) => {
    const attributes = ['id', 'email', 'first_name', 'last_name', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes, ...(query && { query }) };
    const response = await axios.get('/managers', { params });

    return response.data;
  } 
});
export const getManager = asyncThunkWrapper({ 
  model: 'managers', 
  action: 'getManager', 
  func: async (id) => {
    const attributes = ['id', 'email', 'first_name', 'last_name', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/managers/${id}`, { params });

    return response.data;
  } 
});
export const createManager = asyncThunkWrapper({ 
  model: 'managers', 
  action: 'createManager', 
  func: async ({ manager, invitation_token }) => {
    const attributes = ['id', 'email', 'first_name', 'last_name', 'updated_at'];
    const response = await axios.post('/managers', { manager, invitation_token, attributes });

    return response.data;
  } 
});
export const updateManager = asyncThunkWrapper({ 
  model: 'managers', 
  action: 'updateManager', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/managers/${id}`, { manager: { ...fields } });

    return { status: response.status, manager: { id, ...fields } };
  } 
});
export const deleteManager = asyncThunkWrapper({ 
  model: 'managers', 
  action: 'deleteManager', 
  func: async (id) => {
    const response = await axios.delete(`/managers/${id}`);
      
    return { status: response.status, id };
  } 
});
export const clearLocalManagers = createAction('managers/clearLocalManagers');
export const clearLocalActiveManager = createAction('managers/clearLocalActiveManager');